import { z } from 'zod';
var applicationRequirementQuestionFormatTypes = ['checkboxes', 'dropdown', 'short_answer', 'long_answer', 'date', 'url', 'number'];
export var QuestionsSchema = z.array(z.object({
  id: z.string(),
  question: z.string(),
  questionFormat: z["enum"](applicationRequirementQuestionFormatTypes),
  options: z.array(z.string()).optional()
}));
export var UserPermissionsSchema = z.object({
  type: z.literal('user_permissions'),
  attributes: z.object({
    permissions: z.object({
      view_insights: z["boolean"]().optional(),
      view_road_runner_dashboard: z["boolean"]().optional(),
      update_road_runner_dashboard: z["boolean"]().optional(),
      modify_application_requirement_deadline: z["boolean"]().optional(),
      view_internal_notices: z["boolean"]().optional(),
      destroy_requirement_attachment_for_pii: z["boolean"]().optional(),
      change_application_program_outside_original_school_group: z["boolean"]().optional(),
      p_view_orders: z["boolean"]().optional(),
      list_road_runner_workflows: z["boolean"]().optional(),
      get_evaluation_task: z["boolean"]().optional(),
      update_requirement_status: z["boolean"]().optional(),
      fulfil_requirement: z["boolean"]().optional(),
      add_application_requirement: z["boolean"]().optional(),
      read_past_stages_optional_requirements: z["boolean"]().optional(),
      list_all_requirements: z["boolean"]().optional()
    })
  })
});
export var WorkflowSchema = z.object({
  id: z.string(),
  type: z.literal('evaluation_flow'),
  attributes: z.object({
    status: z.union([z.literal('Created'), z.literal('Traversing recipe'), z.literal('Executing task'), z.literal('Done'), z.literal('Failed'), z.literal('Canceled'), z.literal('Waiting for dependant flows'), z.literal('Paused')]),
    programLegacyId: z.number()["int"](),
    schoolLegacyId: z.number()["int"](),
    applicationId: z.string(),
    applicationNumber: z.number()["int"](),
    applicationRequirementId: z.number()["int"](),
    requirementTemplateId: z.string(),
    requirementTemplateNumber: z.number()["int"](),
    requirementTemplateVersion: z.string().optional(),
    requirementInternalTitle: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().nullable()
  })
});
export var WorkflowStepsSchema = z.object({
  id: z.string(),
  type: z.literal('evaluation_task'),
  attributes: z.object({
    applicationId: z.string(),
    applicationNumber: z.number()["int"](),
    applicationRequirementId: z.union([z.string(), z.number()]),
    // getEvaluationTask endpoint returns number, getEvaluationTasks returns string
    applicationRequirementInternalTitle: z.string(),
    studentLegacyId: z.number()["int"](),
    status: z.union([z.literal('Done'), z.literal('Canceled'), z.literal('Error'), z.literal('Failed'), z.literal('Executing'), z.literal('Paused'), z.literal('Waiting'), z.literal('Pending execution'), z.literal('Pending Execution'), z.literal('Snoozed')]),
    assignedAt: z.string().nullish().nullish(),
    assigneeLegacyId: z.number()["int"]().nullish(),
    assigneeEmail: z.string().nullish(),
    taskType: z.string(),
    nodeTemplateName: z.string().nullish(),
    additionalData: z.record(z.string(), z.unknown()).optional(),
    createdAt: z.string(),
    updatedAt: z.string().nullish(),
    completedAt: z.string().nullish(),
    outcomeHandleDisplayName: z.string().nullish(),
    outcomeData: z.record(z.string(), z.unknown()).nullish()
  })
});
export var WorkflowStatusTagIntent = /*#__PURE__*/function (WorkflowStatusTagIntent) {
  WorkflowStatusTagIntent["RUNNING"] = "primary";
  WorkflowStatusTagIntent["FAILED"] = "negative";
  WorkflowStatusTagIntent["SUCCESS"] = "positive";
  WorkflowStatusTagIntent["WAITING"] = "warning";
  WorkflowStatusTagIntent["NEUTRAL"] = "secondary";
  return WorkflowStatusTagIntent;
}({});
export var RequirementTemplateType = z["enum"](['disclaimer', 'document', 'hybrid', 'payment', 'questions', 'receipt']);